module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchInPatternsLabel":"search in text reuse patterns","placeholder":"search in text reuse patterns ...","sort":{"default":"Default","passagesCount":"Number of passages","asc":"↑","desc":"↓"}}}')
  delete Component.options._Ctor
}
